import { FLAVORS, FLAVOR_NAMES, FLAVOR_CATEGORIES, type Flavor } from './flavors'
import { getPairLevel, LEVEL_META, type FlavorLevel } from './flavorLevels'

export { FLAVORS, FLAVOR_NAMES, FLAVOR_CATEGORIES, LEVEL_META }
export type { Flavor, FlavorLevel }
export { getPairLevel }

const BY_SLUG = new Map(FLAVORS.map(f => [f.slug, f]))

/** Вкус со своей плиткой по slug (или undefined для «листовых» вкусов). */
export const getFlavor = (slug: string): Flavor | undefined => BY_SLUG.get(slug)

/** Отображаемое имя вкуса по slug — работает и для «листовых» вкусов без плитки. */
export const getFlavorName = (slug: string): string =>
  FLAVOR_NAMES[slug] ?? slug

/** Вкусы, сгруппированные по категориям в книжном порядке. */
export const getFlavorsByCategory = (): { category: string; flavors: Flavor[] }[] =>
  FLAVOR_CATEGORIES.map(category => ({
    category,
    flavors: FLAVORS.filter(f => f.category === category),
  }))

/** Порядок сортировки сочетаний: сначала размеченные (классика→смело), потом нейтральные. */
const LEVEL_ORDER: Record<FlavorLevel, number> = {
  classic: 0,
  interesting: 1,
  bold: 2,
}

/** Сочетания вкуса, отсортированные по уровню, затем по алфавиту. */
export const getPairings = (
  flavor: Flavor,
): { slug: string; name: string; level: FlavorLevel | null }[] =>
  flavor.pairings
    .map(slug => ({
      slug,
      name: getFlavorName(slug),
      level: getPairLevel(flavor.slug, slug),
    }))
    .sort((a, b) => {
      const la = a.level ? LEVEL_ORDER[a.level] : 99
      const lb = b.level ? LEVEL_ORDER[b.level] : 99
      if (la !== lb) return la - lb
      return a.name.localeCompare(b.name, 'ru')
    })
